import {http} from '@/http'

export default {
  list(data, params) {
    return http.post('/employees/list', data, {params})
  },
  download(data) {
    return http.post('/employees/xlsx', data, { responseType: 'blob' })
  },
  listAll() {
    return http.get('/employees')
  },
  listByCompany(companyId, excludeEmployeeId) {
    return http.get(`/employees/by-company/${companyId}`, {
      params: excludeEmployeeId ? { excludeEmployeeId } : {},
    })
  },
  listActiveManagers(excludeEmployeeId) {
    return http.get('/employees/active-managers', {
      params: excludeEmployeeId ? { excludeEmployeeId } : {},
    })
  },
  listActive() {
    return http.get('/employees/active')
  },
  changeStatus(id, status) {
    return http.put(`/employees/${id}/status`, null, {params: {status}})
  },
  save(data) {
    return http.post('/employees', data)
  },
  update(id, data) {
    return http.put(`/employees/${id}`, data)
  },
  get(id) {
    return http.get(`/employees/${id}`)
  },
  queryDni(dni) {
    return http.get(`/employees/dni/${dni}`)
  },
  getCompliance(id) {
    return http.get(`/employees/${id}/compliance`)
  },
  uploadPhoto(id, file) {
    const fd = new FormData()
    fd.append('file', file)
    return http.post(`/employees/${id}/photo`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  deletePhoto(id) {
    return http.delete(`/employees/${id}/photo`)
  },
  getPhoto(id) {
    return http.get(`/employees/${id}/photo`, { responseType: 'blob' })
  },
  downloadFotocheck(id) {
    return http.get(`/employees/${id}/fotocheck`, { responseType: 'blob' })
  },
}
